import React, { Component } from "react";
import { Typography, Button } from "@mui/material";
import "./Cometblackstorm.css";

class HeroPriceSection extends Component {
  render() {
    const {
      basePrice,
      mainPrice,
      buttonText,
      desktopBg,
      mobileBg,
      overlayWidth,
    } = this.props;

    return (
      <section
        className="comet-hero"
        style={{
          backgroundImage: `url(${desktopBg})`,
        }}
      >
        <div className="price-overlay" style={{
            width: overlayWidth || "43vw", // 👈 default same rahega
          }}>
          <Typography className="price-small">
            {basePrice}
          </Typography>

          <Typography id="price-main">
            {mainPrice}
          </Typography>

          <Button variant="outlined" className="brochure-btn">
            {buttonText}
          </Button>
        </div>

        {/* Mobile background switch */}
        <style>
          {`
            @media (max-width: 480px) {
              .comet-hero {
                background-image: url(${mobileBg});
              }
            }
          `}
        </style>
      </section>
    );
  }
}

export default HeroPriceSection;
